const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/privacy-policy",
    component: "Home/PrivacyPolicy",
    exact: true,
  }
];

export default routes;
